import { getUserDocument } from './getUserDocument'

import { serverTimestamp, setDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function getOrCreateCurrentUserDocument(authUser) {
  const userId = authUser.uid
  let userData = await getUserDocument(userId)
  if (!userData) {
    userData = {
      uid: userId,
      name: authUser.displayName || authUser.name || null,
      // use a firestore timestamp
      created: serverTimestamp(),
      email: authUser.email || null,
      photoURL: authUser.photoURL || null,
      lastSeen: +new Date(),
    }
    await setDoc(refs.user(userId), userData)
  }
  return userData
}
